import { AllStatsCOMResponse } from '../../../types/api/endpoints/stats/stats.types';
import { STATS_ENDPOINTS } from '../../../utils/api/endpoints/statsEndpoints';

const PREFIX = '[allStatsCOMQuery]';

export const queryAllStatsCOM = async () => {
  console.log(PREFIX, `Fetching all COM stats...`);
  const response = await STATS_ENDPOINTS.allStatsCOM();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all COM stats.`);
  return json as AllStatsCOMResponse;
};
